module.exports = __webpack_public_path__ + "img/private_plot.e8797a16.svg";